var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDescriptionChange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.42156 5.3998C3.66156 4.1998 4.74156 3.2998 6.00156 3.2998C6.90156 3.2998 7.62156 3.7198 8.10156 4.3798L9.12156 3.1798C8.40156 2.3398 7.26156 1.7998 6.00156 1.7998C3.90156 1.7998 2.16156 3.3598 1.86156 5.3998H0.601562L2.70156 7.7998L4.80156 5.3998H3.42156ZM9.30156 4.1998L7.20156 6.5998H8.58156C8.28156 7.7998 7.26156 8.6998 6.00156 8.6998C5.10156 8.6998 4.38156 8.2798 3.90156 7.6198L2.88156 8.7598C3.60156 9.6598 4.74156 10.1998 6.00156 10.1998C8.10156 10.1998 9.84156 8.6398 10.1416 6.5998H11.4016L9.30156 4.1998Z",
    fill: "url(#paint0_linear_3_166)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_166",
    x1: 0.601562,
    y1: 1.7998,
    x2: 12.8421,
    y2: 6.08383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABB18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C48E02"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescriptionChange);
export default __webpack_public_path__ + "static/media/description_change.297b5d44c5229ad3f61af1b2fe4e8587.svg";
export { ForwardRef as ReactComponent };